
import { Link } from 'react-router-dom';
import api from '../function/axiosInterceptor';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { useEffect, useState } from 'react';
const Volunteer = () => {
    const images = [
  "/main/files/static/Gallary/g1.jpg",
  "/main/files/static/Gallary/g4.jpg",
  "/main/files/static/Gallary/g5.jpg",
  "/main/files/static/Gallary/g6.jpg",
  "/main/files/static/Gallary/g7.jpg",
  "/main/files/static/Gallary/g8.jpg",
  "/main/files/static/Gallary/g9.jpg",
  "/main/files/static/Gallary/g10.jpg",
  "/main/files/static/Gallary/g11.jpg",
  "/main/files/static/Gallary/g12.jpg",
  "/main/files/static/Gallary/g13.jpg",
  "/main/files/static/Gallary/g14.jpg",
  "/main/files/static/Gallary/g15.jpg",
  "/main/files/static/Gallary/g16.jpg",
  "/main/files/static/Gallary/g17.jpg",
  "/main/files/static/Gallary/g18.jpg",
  "/main/files/static/Gallary/g19.jpg",
  "/main/files/static/Gallary/g20.jpg",
  "/main/files/static/Gallary/g21.jpg",
  "/main/files/static/Gallary/g22.jpg",
  "/main/files/static/Gallary/g23.jpg",
  "/main/files/static/Gallary/g24.jpg",
  "/main/files/static/Gallary/g3.jpg",
  "/main/files/static/Gallary/g25.jpg"
];
 const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
    const [gallery,setgallery] = useState({banner: {},gallery: []});
    useEffect(()=>{
        api.get('/getgallery').then((res)=>{
            if(res.status===200 && res.data.status==='success'){
                setgallery(res.data.data);
            }
            console.log(res);
        }).catch((error)=>{
            console.log(error);
        })
    },[])
    return (<>
        <div className="breadcrumb-area" style={{ backgroundImage: "url(" + process.env.REACT_APP_IMG_BASE_URL + "/img/" + gallery?.banner[0]?.image + ")" }}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="breadcrumb-inner">
                            <div className="icon">
                                <img src="/main/files/static/green-hart.png" />
                            </div>
                            <h2 className="page-title">Gallery</h2>
                            <ul className="page-list">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="#">Gallery</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

         <section className="volunteer-area bg-image m-top-02 padding-bottom-90 padding-top-120">
      <div className="container">
        <div className="row g-2 gallery">

          {images.map((img, i) => (
            <div className="col-lg-3 col-sm-4 col-6" key={i}>
              <div className="team-single-item">
                <div
                  className="thumb"
                  onClick={() => {
                    setIndex(i);
                    setOpen(true);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img src={img} alt="" />
                </div>
              </div>
            </div>
          ))}

        </div>
      </div>

      {/* Lightbox */}
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={images.map((img) => ({ src: img }))}
      />
    </section>
    

         {/* {
                        gallery.gallery && gallery.gallery.map((img)=>{
                            return(<div className="col-lg-3 col-sm-6">
                            <div className="team-single-item">
                                <div className="thumb">
                                    <img src={`${process.env.REACT_APP_IMG_BASE_URL}/gallery/${img.image}`}/>
                                </div>
                            </div>
                        </div>  )
                        })
                    }  */}
    </>)
}
export default Volunteer;